/**
 * Private modules
 */
const {
  alias,
  createQueryComponent,
  customerId,
  isSelected,
  objectId,
  objectIds,
  percent,
  systemGameId,
} = require('../.private').components;

/**
 * Scopes
 */
const {
  CUSTOMER_RUNNER_TICKET_ADDONS_ARCHIVED_BY_SYSTEM_GAME_ID,
  CUSTOMER_RUNNER_TICKET_ADDONS_INPUT_BY_SYSTEM_GAME_ID,
  DEFAULT,
} = require('../../scopes');

module.exports = {
  archiveCustomerRunnerTicketAddonsBySystemGameId: {
    properties: {
      body: {
        properties: {
          objectIds,
        },
        required: ['objectIds'],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  copyCustomerRunnerTicketAddonsBySystemGameId: {
    properties: {
      params: {
        properties: {
          customerId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
        ],
        type: 'object',
      },
    },
    required: ['params'],
    type: 'object',
  },
  createCustomerRunnerTicketAddonBySystemGameId: {
    properties: {
      body: {
        properties: {
          alias,
          entries: {
            items: {
              properties: {
                objectId: {
                  oneOf: [
                    {
                      pattern: '^\\d+$',
                      type: 'string',
                    },
                    {
                      type: 'number',
                    },
                  ],
                },
                percent,
              },
              required: [
                'objectId',
                'percent',
              ],
              type: 'object',
            },
            minItems: 1,
            type: 'array',
            uniqueItems: true,
          },
        },
        required: [
          'alias',
          'entries',
        ],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  deleteCustomerRunnerTicketAddonsBySystemGameId: {
    properties: {
      body: {
        properties: {
          objectIds,
        },
        required: ['objectIds'],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  getCustomerRunnerTicketAddonsBySystemGameId: {
    properties: {
      params: {
        properties: {
          customerId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
        ],
        type: 'object',
      },
      query: createQueryComponent([
        CUSTOMER_RUNNER_TICKET_ADDONS_ARCHIVED_BY_SYSTEM_GAME_ID,
        CUSTOMER_RUNNER_TICKET_ADDONS_INPUT_BY_SYSTEM_GAME_ID,
        DEFAULT,
      ]),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  unarchiveCustomerRunnerTicketAddonsBySystemGameId: {
    properties: {
      body: {
        properties: {
          objectIds,
        },
        required: ['objectIds'],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  updateCustomerRunnerTicketAddonById: {
    properties: {
      body: {
        properties: {
          alias,
          isSelected,
        },
        required: [
          'alias',
          'isSelected',
        ],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          objectId,
        },
        required: [
          'customerId',
          'objectId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
};
